import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import ButtonCopyDetails from '@components/common/ButtonCopyDetails/ButtonCopyDetails';

import useTranslation from '@hooks/useTranslation';

import type { IRecommendation } from '../../model/recommendation';
import ShortDescriptionSkeleton from './ShortDescriptionSkeleton';
import style from './style.module.scss';

interface IProps {
  id?: string;
  recommendationsData: {
    list: Array<IRecommendation>;
    info: Array<string>;
  };
  isFetching: boolean;
}

const ShortDescription: React.FC<IProps> = ({ id, recommendationsData, isFetching }) => {
  const { t } = useTranslation();

  if (isFetching) return <ShortDescriptionSkeleton />;

  return (
    <div className={style.shortDescriptionWrapper}>
      <div className={style.blockHead}>
        <div className={style.blockTitle} id={id}>
          {t('Short Description')}
          <ButtonCopyDetails
            id="copyRecommendedActions"
            copyDetailsData={recommendationsData?.info}
            tooltipInfo={t('Copy recommended actions.')}
          />
        </div>
      </div>
      <div className={style.shortDescription}>
        <div className={style.shortDescriptionHeader}>
          <div className={style.shortDescriptionHeaderItem}>{t('Component type')}</div>
          <div className={style.shortDescriptionHeaderItem}>{t('Fault Name')}</div>
          <div className={style.shortDescriptionHeaderItem}>{t('Recommendations')}</div>
          <div className={style.shortDescriptionHeaderItem}>{t("Fault's Severity")}</div>
        </div>
        <div className={style.shortDescriptionBody}>
          {recommendationsData?.list.map((component) =>
            component.faults.map((fault, index) => (
              <div key={uuidv4()} className={style.shortDescriptionBodyRow}>
                <div className={style.shortDescriptionItem}>{!index && component.label}</div>
                <div className={style.shortDescriptionItem}>{fault.label}</div>
                <div className={style.shortDescriptionItem}>{fault.text}</div>
                <div className={style.shortDescriptionTags}>
                  <div className={style.shortDescriptionTag}>{fault.severity}</div>
                </div>
              </div>
            )),
          )}
        </div>
      </div>
    </div>
  );
};

export default ShortDescription;
